<template>
  <div>
    <el-card class="refund_home" shadow="hover">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="primary" plain circle icon="el-icon-pie-chart" @click="gotoPage('/Refund/Refund')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="warning" plain circle icon="el-icon-pie-chart" @click="gotoPage('/Refund/myApproveListYet')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="danger" plain circle icon="el-icon-pie-chart" @click="gotoPage('/Refund/myRefundList')"></el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-button type="success" plain circle icon="el-icon-pie-chart" @click="gotoPage('/Refund/ccRefund')"></el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">发起退款</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">我已审批</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">我发起的</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="sub">抄送我的</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="hover">
    <el-row>
      <!-- 面包屑导航区域 -->
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/Refund/myApproveList' }">退款系统</el-breadcrumb-item>
          <el-breadcrumb-item>待我审批</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- 搜索框区域 -->
    <!-- <el-row>
      <el-col :span="7">
        <el-input 
        placeholder="请输入退款账户名称" class="input-with-select" v-model="keywords">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col style="text-align:left;" :span="2">
        <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
      </el-col>
    </el-row>
    <!-- 表格区域 -->
    <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="Title" label="标题" width="280"></el-table-column>
      <el-table-column prop="StepName" label="当前步骤" width="180"></el-table-column>
      <el-table-column prop="ReceiveName" label="处理人" width="200"></el-table-column>
      <el-table-column prop="SenderTime" label="发起时间"></el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-tooltip content="通过" placement="top" :enterable="false" v-if="scope.row.StepName == '财务审核' ? false : true">
            <el-button type="success" size="mini" icon="el-icon-circle-check" circle @click="pass(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="完成" placement="top" :enterable="false" v-if="scope.row.StepName == '财务审核' ? true : false">
            <el-button type="success" size="mini" icon="el-icon-check" circle @click="finsh(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="驳回" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-close" circle  size="mini" @click="reject(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="通过并抄送" placement="top" :enterable="false" v-if="scope.row.StepName == '财务审核' ? false : true" >
            <el-button type="info" icon="el-icon-s-promotion" size="mini" circle @click="ccDialogBox(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="转交" placement="top" :enterable="false">
            <el-button type="warning" icon="el-icon-refresh" size="mini" circle @click="transmitDialogBox(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="查看" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-view" size="mini" circle @click="DialogBox(scope.row)"></el-button>
          </el-tooltip>
          <el-dialog title="审批详情" :visible.sync="DialogVisible" width="70%" center>
            <div class="drawer_box">
              <el-steps :active="level" align-center>
                <el-step v-for="(item, index) in TimeLines" :key="index" :title="item.Name" :status="item.Result">
                  <template slot="description">
                    <div>{{item.CompletedTime}}</div>
                    <div>{{item.Handler}}</div>
                    <div>{{item.ResultMessage}}</div>
                  </template>
                </el-step>
              </el-steps>
              <el-row class="box_info" :gutter="20">
                <el-col :span="10" style="text-algin:right;">
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundTypes ? true : false">
                    退款类型
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.OrderNo ? true : false">
                    订单号
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.MainName ? true : false">
                    申请部门
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.TrueName ? true : false">
                    申请人
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.ComanyName ? true : false">
                    公司名称
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.LinkName ? true : false">
                    客户联系人
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.LinkPhone ? true : false">
                    客户联系电话
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.Product !=='' ? true : false">
                    退款产品
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundStyle !=='' ? true : false">
                    退款方式
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsOpenTicket !=='' ? true : false">
                    是否开发票
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsAgreement !=='' ? true : false">
                    是否签合同
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsOpen !=='' ? true : false">
                    是否开户
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsBack !=='' ? true : false">
                    是否撤单完成
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveAgreement !=='' ? true : false">
                    是否有合同
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfA ? true : false">
                    是否有合同原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveReceipt !=='' ? true : false">
                    是否有收据
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfR ? true : false">
                    是否有收据原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveTicket !=='' ? true : false">
                    是否有发票
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfT ? true : false">
                    是否有发票原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundMoney !=='' ? true : false">
                    退款金额
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundBecause ? true : false">
                    退款原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundBecauseOf ? true : false">
                    退款原因详情
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.AccountName ? true : false">
                    用户名
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsLoseTicket !=='' ? true : false">
                    发票是否遗失
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsDeposit !=='' ? true : false">
                    预存款是否消费完毕
                  </div>
                  <div  class="grid-content bg-purple text_right" v-if="rowInfo.ConsumeMoney !== '' ? true : false">
                    已消费金额
                  </div>
                  <!-- 上传资料部分 -->
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.RefundConfirmation ? true : false">
                    退款确认书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Qualifications ? true : false">
                    主体资质复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.LegalCard ? true : false">
                    法人身份证复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Entrust ? true : false">
                    委托授权书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.EntrustCard ? true : false">
                    被委托人身份证复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Ticket ? true : false">
                    发票
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Agreement ? true : false">
                    合同
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Receipt ? true : false">
                    收据
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.TicketLose ? true : false">
                    发票遗失说明
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Transfers ? true : false">
                    转账确认书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Customer ? true : false">
                    客户资质
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.AccountPic ? true : false" >
                    两个账户后台截图
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.License ? true : false">
                    两个账户营业执照复印件
                  </div>
                </el-col>

                <!-- 绑定值区域 -->
                <el-col :span="8">
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundTypes ? true : false">
                    {{ rowInfo.RefundTypes }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.OrderNo ? true : false">
                    {{ rowInfo.OrderNo }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.MainName ? true : false">
                    {{ rowInfo.MainName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.TrueName ? true : false">
                    {{ rowInfo.TrueName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.ComanyName ? true : false">
                    {{ rowInfo.ComanyName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.LinkName ? true : false">
                    {{ rowInfo.LinkName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.LinkPhone ? true : false">
                    {{ rowInfo.LinkPhone }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.Product !=='' ? true : false">
                    {{ rowInfo.Product }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundStyle !=='' ? true : false">
                    {{ rowInfo.RefundStyle }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsOpenTicket !=='' ? true : false">
                    {{ rowInfo.IsOpenTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsAgreement !=='' ? true : false">
                    {{ rowInfo.IsAgreement == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsOpen !=='' ? true : false">
                    {{ rowInfo.IsOpen == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsBack !=='' ? true : false">
                    {{ rowInfo.IsBack == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveAgreement !=='' ? true : false">
                    {{ rowInfo.IsHaveAgreement == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfA ? true : false">
                    {{ rowInfo.BecauseOfA }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveReceipt !=='' ? true : false">
                    {{ rowInfo.IsHaveReceipt == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfR ? true : false" >
                    {{ rowInfo.BecauseOfR }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveTicket !=='' ? true : false">
                    {{ rowInfo.IsHaveTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfT ? true : false">
                    {{ rowInfo.BecauseOfT }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundMoney !=='' ? true : false" >
                    {{ rowInfo.RefundMoney }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundBecause ? true : false">
                    {{ rowInfo.RefundBecause }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundBecauseOf ? true : false">
                    {{ rowInfo.RefundBecauseOf }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.AccountName ? true : false">
                    {{ rowInfo.AccountName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsLoseTicket !=='' ? true : false">
                    {{ rowInfo.IsLoseTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsDeposit !=='' ? true : false">
                    {{ rowInfo.IsDeposit == 0 ? "否" : "是" }}
                  </div>                
                  <div class="grid-content bg-purple-light" v-if="rowInfo.ConsumeMoney !=='' ? true : false">
                    {{ rowInfo.ConsumeMoney }}
                  </div>
                  <!-- 上传资料区域 -->
                  <div class="grid-content bg-purple-light item_height" v-if="Material.RefundConfirmation ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.RefundConfirmation)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Qualifications ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Qualifications)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.LegalCard ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.LegalCard)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Entrust ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Entrust)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.EntrustCard ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.EntrustCard)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Ticket ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Ticket)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Agreement ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Agreement)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Receipt ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Receipt)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.TicketLose ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.TicketLose)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Transfers ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Transfers)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Customer ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Customer)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.AccountPic ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.AccountPic)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.License ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.License)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-dialog>
          <el-dialog title="通过审批并选择抄送对象" :visible.sync="ccDialogVisible" width="40%" center @close="ccDialogClose">
            <el-row>
              <el-col :span="6">
                <div class="ccDialogText">抄送对象</div>
              </el-col>
              <el-col :span="7">
                <el-cascader :props="ccProps" :show-all-levels="false" size="small" v-model="ccId"></el-cascader>
              </el-col>
              <el-col :span="4">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="ccBtn(scope.row)">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
          <el-dialog title="转交审批" :visible.sync="transmitDialogVisible" width="40%" center @close="transmitDialogClose">
            <el-row>
              <el-col :span="3">
                <div class="ccDialogText">转交对象</div>
              </el-col>
              <el-col :span="7">
                <el-cascader :props="ccProps" :show-all-levels="false" size="small" v-model="ccId" ref="TransmitCascader"></el-cascader>
              </el-col>
              <el-col :span="2">
                <div class="ccDialogText">备注</div>
              </el-col>
              <el-col :span="8">
                <el-input v-model="reason" placeholder="请输入备注" size="small" style="width:220px;"></el-input>
              </el-col>
              <el-col :span="2">
                <div class="ccDialogBtn"><el-button type="primary" size="mini" @click="transmitBtn()">确认</el-button></div>
              </el-col>
            </el-row>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      style="text-align:left;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50 ,100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    </el-card>
  </div>
</template>
<script>
let id = 0;
import {
  GetWaitTasks,
  GetInformationId,
  GetStepTimeLine,
  GetInformation,
  Excuteflow,
  Finshflow,
  Refuse,
  GetFlowSendNextSteps,
  HandOverOper
} from "../../until/ZeusApiSDK/Logic/RefundLogic";
import { GetFrameByParentId,GetUserByParentId } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { cryptoDecode } from "../../until/encrypt.js"

export default {
  //inject: ["reload"],
  data() {
    return {
      userInfo: {},
      keywords: "",
      DialogVisible: false,
      ccDialogVisible : false,
      transmitDialogVisible : false,
      tableData: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      searchInstance: [],
      TimeLines: [],
      level: 0,
      rowInfo: {},
      Material: {},
      ccProps: {},
      ccId:'',
      itemInfo:{},
      taskId : '',
      reason : '',
      transmitName : '',
      loading : true
    };
  },
  methods: {
    gotoPage: function(url) {
      if (url.indexOf("http://") > -1) {
        var sp = url.indexOf("?") > -1 ? "&" : "?";
        window.open(url + sp + "token=" + sessionStorage.getItem("token"));
      } else {
        this.$router.push(url);
      }
    },
    
    //刷新
    Refresh:function(){
      this.GetInformationId();
    },
    /**
     * 获取待办事项(待审批)
     */
    GetInformationId: async function() {
      this.loading = true;
      await GetInformationId(this.keywords).then(async res => {
        this.searchInstance = res.result;
      });
      await GetWaitTasks(
        this.userInfo.userid,
        this.pageIndex,
        this.pageSize,
        this.searchInstance
      ).then(res => {
        this.total = res.TotalCount;
        this.tableData = res.DataList;
        this.loading = false;
      });
    },
    //监听每页展示多少条数据改变事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInformationId();
    },
    //监听当前页码改变事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInformationId();
    },
    /**
     * 撤回审批
     */
    async reject(row) {
      await GetFlowSendNextSteps(
        this.userInfo.userid,
        row.StepID,
        row.InstanceID
      ).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        var paras = {
          flowid: "44cae30c-23a0-4f36-aa34-914350682380",
          //当前用户id
          senderid: this.userInfo.userid,
          instanceid: row.InstanceID,
          data: [],
          step: step,
          type: "refuse",
          isfirststep: false,
          taskid: row.ID,
          stepid: row.StepID,
          comment: row.Comment,
          groupid: row.GroupID,
          title: row.Title,
          ccid: "",
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        Refuse(paras).then(res => {
          if (res.msg == "已完成") {
            this.$message({
              message: "驳回成功",
              type: "success"
            });
            //this.reload();
            this.GetInformationId();
          } else {
            this.$message.error("驳回失败,请重试");
          }
        });
      });
    },
    /**
     * 通过审批
     */
    async pass(row,ccId) {
      if(ccId == undefined){
        var ccid = '';
      }else{
        var ccid = ccId;
      }
      await GetFlowSendNextSteps(this.userInfo.userid,row.StepID,row.InstanceID).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        var paras = {
          flowid: "44cae30c-23a0-4f36-aa34-914350682380",
          //当前用户id
          senderid: this.userInfo.userid,
          instanceid: row.InstanceID,
          data: [],
          step: step,
          type: "submit",
          isfirststep: false,
          taskid: row.ID,
          stepid: row.StepID,
          comment: row.Comment,
          groupid: row.GroupID,
          title: row.Title,
          ccid: ccid,
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        Excuteflow(paras).then(res => {
          if (res.msg == "操作成功") {
            this.$message({message: "操作成功~",type: "success"});
            //this.reload();
            this.GetInformationId();
          } else {
            this.$message.error("审批失败,请重试");
          }
        });
      });
    },
    /**
     * 完成审批
     */
    async finsh(row,ccId) {
      if(ccId == undefined){
        var ccid = '';
      }else{
        var ccid = ccId;
      }
      await GetFlowSendNextSteps(this.userInfo.userid,row.StepID,row.InstanceID).then(res => {
        var step = [];
        res.forEach(element => {
          var obj = {
            id: element.Step.ID,
            member: element.DefaultMemberID
          };
          step.push(obj);
        });
        var paras = {
          flowid: "44cae30c-23a0-4f36-aa34-914350682380",
          //当前用户id
          senderid: this.userInfo.userid,
          instanceid: row.InstanceID,
          data: [],
          step: step,
          type: "completed",
          isfirststep: false,
          taskid: row.ID,
          stepid: row.StepID,
          comment: row.Comment,
          groupid: row.GroupID,
          title: row.Title,
          ccid: ccid,
          ccname: "",
          sendername: this.userInfo.TrueName
        };
        Finshflow(paras).then(res => {
          if (res.msg == "已完成") {
            this.$message({message: "操作成功~",type: "success"});
            //this.reload();
            this.GetInformationId();
          } else {
            this.$message.error("审批失败,请重试");
          }
        });
      });
    },
    /**
     * 下载模板
     */
    download_doc(file_path) {
      window.open(file_path);
    },
    /**
     * 打开显示详情dialog
     */
    async DialogBox(row) {
      this.DialogVisible = true;
      await GetStepTimeLine(this.userInfo.userid, row.InstanceID).then(res => {
        res.TimeLines.forEach(e => {
          if (e.Result == '0') {
            e.Result = "wait";
          } else if (e.Result == 2) {
            e.Result = "finish";
          } else if (e.Result == 3) {
            e.Result = "error";
          } else if (e.Result == 4) {
            e.Result = "finish";
          } else if (e.Result == 5) {
            e.Result = "error";
          }
        });
        this.TimeLines = res.TimeLines;
        this.level = res.NowStep;
      });
      await GetInformation(row.InstanceID).then(res => {
        if (res.result.RefundTypes == 0) {
          res.result.RefundTypes = "未消费退款";
        } else if (res.result.RefundTypes == 1) {
          res.result.RefundTypes = "已经消费退款";
        } else if (res.result.RefundTypes == 2) {
          res.result.RefundTypes = "已经消费转账户";
        } else if (res.result.RefundTypes == 3) {
          res.result.RefundTypes = "保证金";
        }
        this.rowInfo = res.result;
        this.Material = res.result.Material;
      });
    },
    /**
     * 打开抄送dialog
     */
    async ccDialogBox(row){
      this.itemInfo = row;
      this.ccDialogVisible = true;
      this.ccProps = {
        lazy: true,
        lazyLoad: (node, resolve) => {
          GetFrameByParentId(node.value).then((res) => {
            if (res.length > 0) {
              var nodes = [];
              res.forEach((element) => {
                var node = {
                  value: element.Id,
                  label: element.ClassName,
                  leaf: false,
                };
                nodes.push(node);
              });
              resolve(nodes);
            } else {
              GetUserByParentId(node.value).then((users) => {
                var nodes = [];
                if (users.DataList.length > 0) {
                  users.DataList.forEach((element) => {
                    var node = {
                      value: element.Id,
                      label: element.TrueName,
                      leaf: true,
                    };
                    nodes.push(node);
                  });
                }
                resolve(nodes);
              });
            }
          });
        },
      }
    },
    /**
     * 关闭抄送dialog
     * 并清除行数据
     */
    ccDialogClose(){
      this.itemInfo = {};
    },
    /**
     * 选择抄送人
     */
    onCcChange(val){
      // this.$refs.CcCascader.getCheckedNodes()[0].pathLabels 获得node节点下的label值
      this.ccId = val[val.length-1];
    },
    /**
     * 确认并抄送
     */
    ccBtn(){
      this.ccId = this.ccId[this.ccId.length-1];
      if(this.ccId == ''){
        this.$message('请选择要抄送的对象');
      }else{
        this.pass(this.itemInfo,this.ccId).then(res=>{
          this.ccDialogVisible = false;
        });
      }
    },
    /**
     * 打开转交dialog
     */
    async transmitDialogBox(row){
      this.itemInfo = row;
      this.taskId = row.ID
      this.transmitDialogVisible = true;
      this.ccProps = {
        lazy: true,
        lazyLoad: (node, resolve) => {
          GetFrameByParentId(node.value).then((res) => {
            if (res.length > 0) {
              var nodes = [];
              res.forEach((element) => {
                var node = {
                  value: element.Id,
                  label: element.ClassName,
                  leaf: false,
                };
                nodes.push(node);
              });
              resolve(nodes);
            } else {
              GetUserByParentId(node.value).then((users) => {
                var nodes = [];
                if (users.DataList.length > 0) {
                  users.DataList.forEach((element) => {
                    var node = {
                      value: element.Id,
                      label: element.TrueName,
                      leaf: true,
                    };
                    nodes.push(node);
                  });
                }
                resolve(nodes);
              });
            }
          });
        },
      }
    },
    /**
     * 关闭转交dialog
     * 并清除行数据
     */
    transmitDialogClose(){
      this.itemInfo = {};
    },
    /**
     * 选择转交人
     */
    onTransmitChange(val){
      this.ccId = val[val.length-1];
      // 获得node节点下的label值
      var transmitName = this.$refs.TransmitCascader.getCheckedNodes()[0].pathLabels;
      this.transmitName = transmitName[transmitName.length-1];
    },
    /**
     * 确认并抄送
     */
    transmitBtn(){
      this.ccId = this.ccId[this.ccId.length-1];
      // 获得node节点下的label值
      var transmitName = this.$refs.TransmitCascader.getCheckedNodes()[0].pathLabels;
      this.transmitName = transmitName[transmitName.length-1];
      if(this.reason == ''){
        this.reason = '无'
      }
      if(this.ccId == ''){
        this.$message('请选择要抄送的对象');
      }else{
        HandOverOper(this.userInfo.TrueName,this.transmitName,this.taskId,this.ccId,this.reason).then(res=>{
          if(res.Message == '操作成功'){
            this.$message({message: "操作成功~",type: "success"});
            this.transmitDialogVisible = false;
            //this.reload();
          }else{
            this.$message('操作失败');
          }
        });
      }
    },
  },
  created() {
    // 3503bdf1-e379-4ac1-80d4-b60a5056433c 胡双林 id
    // 06d85c33-df0f-4953-a3e3-690f15d2a7d9 张雨 id
    // 2ada3e15-b153-4dab-93ee-84ba9c2b4848 付亚楠 id
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo.TrueName = userinfo.TrueName
    this.userInfo.userid = userinfo.UserId;
    // this.userInfo.TrueName = "付亚楠";
    // this.userInfo.userid = "2ada3e15-b153-4dab-93ee-84ba9c2b4848";
    this.GetInformationId();
  }
};
</script>
<style lang="less" scoped>
.refund_home{
  height: 100px;
  margin-bottom: 12px;
}
.sub {
  font-size: 12px;
  color: #8f8d8d;
}
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.el-drawer {
  padding: 0 15px !important;
}
.drawer_box {
  width: 100%;
}
.el-dropdown {
  transform: translateY(10px);
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.text_right {
  text-align: right;
}
.text_left {
  text-align: left;
}
.item_height {
  height: 40px;
  line-height: 40px;
}
.ccDialogText{
  text-align: right;
  height: 32px;
  line-height: 32px;
  padding-right: 18px;
}
.ccDialogBtn{
  height: 32px;
  line-height: 32px;
}
</style>
